import styled from '@emotion/styled';
import { Z_LS_ACTIVE_USER_CTA } from '@embed/components/VideoPlayer/Player3/constants/zIndexes';
export const StyledContainer = styled.button `
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  top: 50%;
  left: 50%;
  justify-content: center;
  position: absolute;
  transform: translate(-50%, -50%);
  width: 100%;
  height: calc(
    100% - (80px + 80px)
  ); // 80px roughly covers the each height of header and footer main controls. Container should not cover them.
  zoom: var(--ui-zoom);
  z-index: ${Z_LS_ACTIVE_USER_CTA};
`;
export const StyledCTAText = styled.div `
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
export const StyledCTAIcon = styled.div `
  background-color: ${({ background }) => background || 'rgb(64 64 64 / 50%)'};
  border-radius: 64px;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`;
export const StyledCTAIconText = styled.div `
  margin: 10px;
  font-size: 18px;
  font-weight: 500;
`;
export const StyledCTAButton = styled.div `
  border: none;
  display: inline-flex;
  align-items: center;
  column-gap: 12px;
  background-color: rgb(64 64 64 / 50%);
  padding: 12px 16px;
  border-radius: 6px;
  max-width: 100%;
`;
